import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";
import eventBus from "../../../event-bus/eventBus";

const confirmInvoice = {
    namespaced: true,
    state: {
        confirmInvoiceFetching: false,
    },
    mutations: {
        CONFIRM_INVOICE_SUCCESS(state, response) {
            eventBus.$emit('confirmInvoiceSuccess', response.data);
            state.confirmInvoiceFetching = false;
        },
        CONFIRM_INVOICE_FAILURE(state, error) {
            state.confirmInvoiceFetching = false;
            if (error.response.data.errors.type && error.response.data.errors.type[0] === 'diskLimitExceeded') {
                eventBus.$emit('projectDiskLimitExceeded', error.response.data.errors);
            } else {
                console.log(error);
            }
        },
    },
    actions: {
        confirmInvoiceRequest: function({dispatch, state}, value) {
            state.confirmInvoiceFetching = value;
            let promise = sendRequest("post", config.baseURLApi + "/invoices/confirm/" + value, {});
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successConfirmInvoice", result[1]);
                } else {
                    dispatch("failureConfirmInvoice", result[1]);
                }
            })
        },
        successConfirmInvoice: function({commit}, response) {
            commit("CONFIRM_INVOICE_SUCCESS", response);
        },
        failureConfirmInvoice: function({commit}, error) {
            commit("CONFIRM_INVOICE_FAILURE", error);
        },
    }
}

export default confirmInvoice;